import Styled, { css, withTheme } from "styled-components";
import Media from "../../utils/media";

const Loader = Styled.div`
  // display:${props => (props.isLoading ? "block" : "none")};
	height:2px;
	position: fixed;
	top: 58px;
	${Media.desktop` 
		position: relative;
		top: 0;
	`};
	width: ${props => (props.isSwipable ? "100vw" : "auto")};
	background: #	F8F8F8;
  ${props =>
    props.isLoading &&
    css`
      background: ${props =>
        `linear-gradient(90deg, #F8F8F8, ${
          props.theme.computedPrimary
        }, #F8F8F8)`};
      background-size: 400% 400%;
      -webkit-animation: Gradient 2s ease infinite;
      -moz-animation: Gradient 2s ease infinite;
      animation: Gradient 2s ease infinite;
    `};
	
@-webkit-keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

@-moz-keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

@keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}
`;

export default withTheme(Loader);
